// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_ToggleInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_ToggleInput — body for POST /franchisor-channels/toggle.
 * Quick enable/disable of a channel row (distinct from a full save()).
 */
import { registerContract } from './validate'

export interface FranchisorChannels_ToggleInput {
id: number
enabled: boolean
}

registerContract('FranchisorChannels_ToggleInput', {
  id:      { type: 'number',  required: true },
  enabled: { type: 'boolean', required: true },
})
